<template>
<div class="chapter">
<div class="inner_page">
<div class="ibox">
<p class="i-tit">INTRODUCTION</p>
<p class="fig"><img alt="" src="images/pg4.jpg"/></p>
<p class="noindent">Bright and bold; soft and subtle; shiny, matte, and everything in between—this book will show you new and exciting ways to use gorgeous fabrics and incredible colors. Whether you are a traditional quilter, art quilter, or modern quilter, there is a method and style for you in this book.</p>
<p class="bull">•  Layers of shapes and colors fool the eye, allowing you to create dynamic quilts using easy construction techniques.</p>
<p class="bull">•  Interactions of color and pattern will delight you.</p>
<p class="bull">•  Three different construction methods can be applied to endless design possibilities.</p>
<p class="noindent">Throughout this book, you’ll explore options for color, style, scale, and construction. Start with one quilt and you’ll soon be on your way to a series.</p>
<p class="noindent">After reading this book, you will never look at fabrics the same way again.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?9b43f3f4